import { adminPost } from "@/lib/kbAdminClient";
import type { PlatformCostDraft, PlatformCostLedgerRow } from "@/lib/platform/platformCostLedger";

const LEDGER_ACTION = "/api/admin/action?action=platform-cost-ledger";

export type PlatformCostLedgerResult<T> =
  | { ok: true; data: T }
  | { ok: false; error: string; schemaMissing: boolean };

async function postLedger<T>(body: unknown): Promise<PlatformCostLedgerResult<T>> {
  const res = await adminPost<T>(LEDGER_ACTION, body);
  if (!res.ok) {
    return { ok: false, error: res.error, schemaMissing: res.code === "SCHEMA_MISSING" };
  }
  return { ok: true, data: res.data };
}

export function listPlatformCosts() {
  return postLedger<{ ok: true; rows: PlatformCostLedgerRow[] }>({ op: "list" });
}

export function createPlatformCost(draft: PlatformCostDraft) {
  return postLedger<{ ok: true; row: PlatformCostLedgerRow }>({ op: "create", ...draft });
}

export function updatePlatformCost(id: string, draft: PlatformCostDraft) {
  return postLedger<{ ok: true; row: PlatformCostLedgerRow }>({ op: "update", id, ...draft });
}

export function endPlatformCost(id: string, endedOn: string) {
  return postLedger<{ ok: true; row: PlatformCostLedgerRow }>({ op: "end", id, ended_on: endedOn });
}

export function deletePlatformCost(id: string) {
  return postLedger<{ ok: true }>({ op: "delete", id });
}

export function replacePlatformCost(id: string, draft: PlatformCostDraft) {
  return postLedger<{ ok: true; row: PlatformCostLedgerRow }>({ op: "replace", id, ...draft, ended_on: null });
}
